import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useNotify } from "react-admin";

// Bodies are stored as text: JSON for most calls, a "[binary suppressed: …]" marker for multipart uploads, and
// occasionally a bare ЕАН. Pretty-print when it parses, show it verbatim when it does not — a body we cannot
// parse is still evidence and must not be swallowed.
const formatBody = body => {
  if (!body) return null;

  try {
    return JSON.stringify(JSON.parse(body), null, 2);
  } catch {
    return body;
  }
};

const RequestPayloadViewer = ({ title, body }) => {
  const notify = useNotify();
  const formatted = formatBody(body);

  if (!formatted) return null;

  const handleCopy = async event => {
    // The button sits inside the summary, which would otherwise toggle the accordion.
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(formatted);
      notify("Копирано.", { type: "info" });
    } catch (err) {
      // Clipboard access is denied outside a secure context; nothing is broken, the body is still on screen.
      console.error(err);
      notify("Копирането не е разрешено от браузъра.", { type: "warning" });
    }
  };

  return (
    <Accordion
      disableGutters
      sx={{ mt: 1 }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
          <Typography variant="body2">{title}</Typography>
          <Tooltip title="Копирай">
            <IconButton
              size="small"
              onClick={handleCopy}
            >
              <ContentCopyIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          component="pre"
          sx={{
            m: 0,
            p: 2,
            maxHeight: 400,
            overflow: "auto",
            fontFamily: "monospace",
            fontSize: 12,
            whiteSpace: "pre-wrap",
            wordBreak: "break-all",
            bgcolor: theme => (theme.palette.mode === "dark" ? "grey.900" : "grey.100"),
            borderRadius: 1,
          }}
        >
          {formatted}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default RequestPayloadViewer;
